import { c as _c } from "react/compiler-runtime";
import { USER_PLAN_API } from 'modules/profile/user-plan/api/user-plan-api';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function useUserPlan(t0) {
  const $ = _c(8);
  const isFetchAllowed = t0 === undefined ? true : t0;
  const {
    user,
    isWorkspaceOwner,
    isCustomer
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== isCustomer || $[2] !== isWorkspaceOwner || $[3] !== user) {
    t2 = () => {
      if (user && isCustomer && isWorkspaceOwner) {
        return [USER_PLAN_API, user.dashboardLocale];
      }
      return null;
    };
    $[1] = isCustomer;
    $[2] = isWorkspaceOwner;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: userPlanData,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, isFetchAllowed);
  let t3;
  if ($[5] !== mutate || $[6] !== userPlanData) {
    t3 = {
      userPlanData,
      mutate
    };
    $[5] = mutate;
    $[6] = userPlanData;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}